// src/layouts/appnavigation/usercheckout/LoadingScreen.jsx
import React from 'react';
import { CircularProgress, Box } from '@mui/material';

export default function LoadingScreen() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
    >
      <CircularProgress />
    </Box>
  );
}
